import React from 'react';
import { Button } from './Button';
import { BrandSymbol } from '../brand/BrandSymbol';
type CtaBandProps = {
  title?: string;
  text?: string;
  primary?: {
    label: string;
    to: string;
  };
  secondary?: {
    label: string;
    to: string;
  };
};
export function CtaBand({
  title = 'Let’s Find the Right Talent.',
  text = 'Whether you are appointing a leader or considering your next move, a confidential conversation is the best place to start.',
  primary = {
    label: 'Build Your Leadership Team',
    to: '/employers'
  },
  secondary = {
    label: 'Explore Your Next Opportunity',
    to: '/jobs'
  }
}: CtaBandProps) {
  return <section className="bg-ivory py-20 md:py-28" data-id="element-496" data-mp="m35dlkt7su2q">
      <div className="container-page" data-id="element-497" data-mp="m3x8suiwgpsh">
        <div className="relative overflow-hidden rounded-xl bg-midnight px-8 py-14 md:px-16 md:py-20" data-id="element-498" data-mp="h3stv8xn434d">
          <BrandSymbol size={360} className="pointer-events-none absolute -right-16 -top-10 opacity-[0.07]" data-id="element-499" data-mp="2gf28xous2k32" />
          <div className="relative max-w-2xl" data-id="element-500" data-mp="2bibv786g40kt">
            <h2 className="font-display text-4xl font-semibold leading-tight text-white md:text-5xl" data-id="element-501" data-mp="2p63ciqtnjecp">{title}</h2>
            <p className="mt-5 text-lg leading-relaxed text-white/70" data-id="element-502" data-mp="2t7f77arduprr">{text}</p>
            <div className="mt-9 flex flex-wrap gap-3" data-id="element-503" data-mp="2t5c7fz0fhi9u">
              <Button to={primary.to} size="lg" arrow data-id="element-504" data-mp="2f97bt79zvwip">
                {primary.label}
              </Button>
              <Button to={secondary.to} variant="outlineLight" size="lg" data-id="element-505" data-mp="2k7il9gwdo50e">
                {secondary.label}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}